var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('meting-js',{attrs:{"server":"netease","type":"playlist","id":"471071972","volume":"0.1","lrc-type":"0","fixed":"true","theme":"#25CCF7"}})}
var staticRenderFns = []

export { render, staticRenderFns }